<template>
  <b-container class="page-container" fluid>
    <HappyHolidaysCheckout />
  </b-container>
</template>
<style>

</style>

<script>
// @ is an alias to /src
import HappyHolidaysCheckout from "@/components/checkout/happyholidays/HappyHolidaysCheckout.vue";

export default {
  title: 'Dropsmart Happy Holidays Checkout - 30% OFF!',
  name: "HappyHolidaysView",
  components: {
    HappyHolidaysCheckout
  }
};
</script>
